import { UserRound } from "lucide-react";

export function UserAvatar({ imageUrl, name, large = false }: { imageUrl?: string; name?: string; large?: boolean }) {
  return <span className={`avatar ${large ? "large" : ""}`} data-pii>
    {imageUrl ? <img src={imageUrl} alt="" referrerPolicy="no-referrer" data-pii /> : <UserRound aria-hidden="true" />}
    <span className="sr-only" data-pii>{name}</span>
  </span>;
}
